import {Component, Input} from '@angular/core';

@Component({
  selector: 'sellions-circle',
  templateUrl: 'sellions-circle.html'
})
export class SellionsCircleComponent {
  @Input() public color: string;

  constructor() {}

}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-circle/sellions-circle.ts